module.exports = __webpack_public_path__ + "img/gm_pre@2x.738c1575.png";